<ngx-loading-bar color="#347ab7d4" height="3px" [includeSpinner]="false" ref="router"></ngx-loading-bar>
<ngx-loading-bar color="#347ab7d4" height="3px" [includeSpinner]="false" ref="http"></ngx-loading-bar>
<app-header></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>

